import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[IconConstants]" }] */
import IconConstants from 'components/shared/icons/IconConstants';

class DividerIconContainer extends React.Component {
  render() {
    return <DividerIcon {...this.props} />;
  }
}

class DividerIcon extends React.Component {
  static propTypes = {
    backgroundColor: PropTypes.string.isRequired,
  };

  render() {
    const { backgroundColor } = this.props;

    return (
      <div style={{ position: 'relative' }}>
        <svg
          style={{ position: 'absolute' }}
          width="100%"
          height="22px"
          viewBox="0 0 30 30"
          preserveAspectRatio="none"
        >
          <path stroke={IconConstants.FAINT_GREY} strokeWidth="2px" d="M0 15 L30 15" />
        </svg>
        <svg style={{ position: 'absolute' }} width="100%" height="22px" viewBox="0 0 35 30">
          <rect x="0" y="0" width="30" height="30" fill={backgroundColor} />
          <path
            stroke={IconConstants.FAINT_GREY}
            strokeWidth="2px"
            d="M0 15 L10 15 M0 25 L20 5 M15 25 L35 5 M25 15 L35 15"
          />
        </svg>
      </div>
    );
  }
}

export default DividerIconContainer;
